<script lang="ts" setup>
const store = useLivroDiarioAuxiliarStore()
const { modalDownloadComprovantes } = storeToRefs(store)

async function baixarTodosOsAnexos () {
  useStore().loading = true
  await store.downloadComprovantesPorCompetencia()
  modalDownloadComprovantes.exibir = false
  useStore().loading = false
}
</script>

<template>
  <CModal
    v-model:visible="modalDownloadComprovantes.exibir"
    title="Download de comprovantes"
    size="lg"
    @closed="modalDownloadComprovantes.exibir = false"
  >
    <CModalHeader>
      <span class="ms-2">
        Atenção!
      </span>
    </CModalHeader>
    <CModalBody>
      <CRow>
        <CCol>
          <p>Esta ação irá baixar todos os comprovantes unificados de todas as <strong>despesas</strong> da competência selecionada: {{ useStore().competenciaFormatada }}.</p>
          <p>Certifique-se que todos os comprovantes estão anexados corretamente antes de prosseguir.</p>
          <div class="alert alert-warning" role="alert">
            Essa é uma operação que pode levar algum tempo, dependendo da quantidade de comprovantes.
          </div>
        </CCol>
      </CRow>
    </CModalBody>
    <CModalFooter>
      <CButton
        color="primary"
        @click="baixarTodosOsAnexos"
      >
        <CIcon name="cil-cloud-download" /> Baixar comprovantes
      </CButton>
      <CButton
        color="secondary"
        @click="modalDownloadComprovantes.exibir = false"
      >
        Cancelar
      </CButton>
      </CModalFooter> 
  </CModal>
</template>

<style>

</style>
